import { render, staticRenderFns } from "./codiceDownloadReferto.vue?vue&type=template&id=5f658e94&"
import script from "./codiceDownloadReferto.vue?vue&type=script&lang=js&"
export * from "./codiceDownloadReferto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports